export default { options: { label: 'Lineups' } }
